<template>
  <div id="ChatRoom">
    <div v-if="!livetimeend && directStatus !='running'" style="height: 84px;">
       <div class="countDown">
          <p>直播倒计时</p>
          <ul class="times">
            <li>
              {{ days }}
              <span>天</span>
            </li>
            <li>
              {{ hours }}
              <span>时</span>
            </li>
            <li>
              {{ minites }}
              <span>分</span>
            </li>
            <li>
              {{ seconds }}
              <span>秒</span>
            </li>
          </ul>
        </div>
    </div>
    
    <div v-if="noticeObj.open && isNoitceTopShow" style="height: 36px;">
       <div class="noticeBox">
         <van-notice-bar
          class="noticeBar"
          :text="noticeObj.content"
        />
       </div>
    </div>
    
    <div class="right-func-box">
      <div class="link-btn" v-if="(businessConfigs && (businessConfigs.student_room_link_mic_show || businessConfigs.student_room_link_mic_show == undefined))
       && initData.direct_seeding.play_style == 3 && initData.direct_seeding.direct_status == 'running' && playerStatus == 2">
        <img
          @click="onLinkCLick"
          v-if="linkType != 3"
          src="https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmai.png"
        />
        <img
          @click="onLinkEndClick"
          v-if="linkType == 3"
          src="https://tengfaceliveuser.tengface.net/web/wx-user/img/lianmaizhong.png"
        />
        <span @click="onLinkEndClick">连麦互动</span>
      </div>

      <div class="zixun-btn" v-if="isshowCart">
        <img
          @click="onShowGoodsList"
          src="../../../../statics/imgs/cart-Empty.png"
        />
        <span @click="onShowGoodsList">购物车</span>
      </div>

      <div class="zixun-btn" v-if="showTeacherBtn && (!userConfig || (userConfig && userConfig.show_teacher != 0))">
        <img
          @click="onShowTeacherList"
          src="../../../../statics/imgs/zixun_icon.png"
        />
        <span @click="onShowTeacherList">咨询老师</span>
        <span v-show="unReadMsgPointShow" class="unReadMsgPoint"></span>
      </div>

      <div class="zixun-btn" v-if="openWx_follow">
        <img
          @click="$emit('onShowFouceAlert')"
          src="../../../../statics/imgs/guanzhu_icon.png"
        />
        <span @click="onShowTeacherList">关注+</span>
      </div>
      <!-- <div class="zixun-btn" v-if="isThreeScreen">
        <img
          @click="$emit('changeVideoLine')"
          src="https://res-live.tenghuiwangxiao.cn/web/wx-user/wechatlive/img/v_qiehuan.png"
        />
        <span @click="onShowTeacherList">切换线路</span>
      </div> -->
    </div>

    <div
      ref="unReadMessageView"
      @click="onShowTeacherList"
      v-if="showUnReadView"
      class="unReadView unReadViewShowAni"
    >
      <img class="header" v-if="unReadMsgData" :src="unReadMsgData.header" />
      {{ unReadMsgData ? unReadMsgData.content : "" }}
      <i class="sanjiao"></i>
    </div>

    <div id="ChatRoomContent" @scroll="chatScroll" @touchstart="chatTouchstart" @touchmove="chatTouchmove" @touchend="chatTouchend">
      <!-- 聊天列表 -->
      <van-pull-refresh
        id="ChatRoom-bodyId"
        class="ChatRoom-body"
        v-model="isLoading"
        @refresh="loadMore"
      >
        <!-- <div id="ChatRoom-bodyId" class="ChatRoom-body" v-waterfall-upper="loadMore" waterfall-disabled="waterfall_disabled" waterfall-offset="300"> -->
        <template v-if="chatRecord.length">
          <div class="cell" v-for="(item, index) in chatRecord" :key="index">
            <div
              class="comment_cell"
              :class="{
                hostman:
                  item.fans_id == hostId && item.module != 'wall_comment',
                type: styleType == 3,
              }"
            >
              <div class="header">
                <template v-if="item.module != 'wall_comment'">
                  <div v-if="item.fans_id == hostId" class="msg_header">
                    <img class="headimg" :src="item.header" />
                    <img
                      v-if="styleType != 3"
                      class="rank"
                      :src="imgPath + 'room/zhuchiren1.png'"
                    />
                    <img
                      v-else
                      class="rank"
                      :src="imgPath + 'room/zhuchiren3.png'"
                    />
                  </div>
                  <div v-else class="msg_header">
                    <img class="headimg" :src="item.header" />
                  </div>
                </template>
                <template v-else>
                  <div class="msg_header">
                    <img
                      class="occupyRank"
                      :src="imgPath + 'room/headImg-bg.png'"
                    />
                    <img class="headimg" :src="item.header" />
                  </div>
                </template>
                <div class="nameTime">
                  <div
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                    class="floor_name"
                  >
                    <span
                      style="font-size: 12px;line-height: 20px;max-width: 200px;"
                      :style="{color:item.to_fans_id?'#027DB4':'#444444'}"
                      >{{ changeNick(item.nick) }}</span
                    >
                    <span v-if="item.showzhu == 1" class="zhuTeacher">老师</span>
                    <span class="teacher_replay_text" v-if="item.to_fans_id">回复你</span>
                    <span
                      v-if="!(userConfig && userConfig.showCommentTime === 0)"
                      style="font-size: 12px;line-height: 20px;margin-left: 5px;font-size: 10px;"
                      >{{ item.create_time }}</span
                    >
                  </div>
                </div>
              </div>

              <!--主持人评论消息-->
              <div
                v-if="item.module == 'text_comment' && item.fans_id == hostId"
                class="msg_conent"
              >
                <p v-dompurify-html="item.content"></p>
                <div
                  v-if="item.pic_url && item.content"
                  style="height:10px"
                ></div>
                <img
                  v-if="item.pic_url"
                  class="contImg"
                  :src="item.pic_url"
                  @click="preview(item.pic_url)"
                />
                <img class="xinxin1" :src="imgPath + 'room/xinxin1_03.png'" />
                <img class="xinxin2" :src="imgPath + 'room/xinxin2_03.png'" />
                <img class="xinxin3" :src="imgPath + 'room/fff_03.png'" />
              </div>

              <!--这里是普通的评论消息-->
              <div
                v-else-if="
                  item.module == 'text_comment' && item.fans_id != hostId
                "
                class="comment-text"
              >
                <p style="font-size: 13px;word-break: break-all;white-space: pre-line;"
                  v-dompurify-html="item.content"></p>
                <div
                  v-if="item.pic_url && item.content"
                  style="height:10px"
                ></div>
                <img
                  v-if="item.pic_url"
                  class="contImg"
                  :src="item.pic_url"
                  @click="preview(item.pic_url)"
                />
                <div
                  class="sublist"
                  v-for="(sublist, index) in item.sublist"
                  :key="index"
                >
                  <div class="title clearfix">
                    <span class="fl">{{ sublist.nick }}</span>
                    <span class="fr time">{{
                      sublist.create_time.substr(5, sublist.create_time.length)
                    }}</span>
                  </div>
                  <p v-dompurify-html="sublist.content"></p>
                </div>
                <span v-if="item.showcopytext" class="copyText" @click="copyTextTap(item.content)">复制</span>
              </div>
              <!-- 通知 -->
               <div
                v-else-if="item.module == 'notice'"
                class="comment-text"
              >
                <p style="font-size: 13px;word-break: break-all;"
                  v-dompurify-html="item.content"></p>
              </div>
              <!-- 抢红包 -->
              <div
                v-else-if="item.module == 'redpack_comment'"
                class="red-pack"
                @click="robRedBagAction(item)"
              >
                <div class="red-pack-header">
                  <img
                    class="red-pack-img"
                    :src="imgPath + 'room/redpack_03.png'"
                  />
                  <div class="red-pack-title">
                    <p v-if="item.content" class="ellipsis">
                      {{ item.content }}
                    </p>
                    <p v-else>恭喜发财，大吉大利</p>
                    <p class="red-pack-desc">拼手气红包，先到先得</p>
                  </div>
                </div>
                <div class="red-pack-body">
                  <div
                    class="red-pack-item clearfix"
                    v-for="(redpack, index) in item.sublist"
                    :key="index"
                  >
                    <span class="red-pack-item-name fl"
                      >{{ redpack.nick }}：</span
                    >
                    <span class="red-pack-item-money"
                      >￥{{ redpack.total_money / 100 }}</span
                    >
                    <span class="red-pack-item-time fr">{{
                      redpack.create_time.split(" ")[1]
                    }}</span>
                  </div>
                </div>
              </div>
              <!-- 主办方红包 -->
              <div
                v-else-if="item.module == 'reward_redpacket_comment'"
                class="red-pack"
              >
                <div class="red-pack-header">
                  <img
                    class="red-pack-img"
                    :src="imgPath + 'room/redpack_03.png'"
                  />
                  <div class="red-pack-title">
                    <p v-if="item.content" class="ellipsis">
                      {{ item.content }}
                    </p>
                    <p v-else>恭喜发财，大吉大利</p>
                    <p class="red-pack-desc ellipsis" v-if="ds_id != 194">
                      向主办方打赏了一个{{ item.total_money / 100 }}元的红包
                    </p>
                    <p class="red-pack-desc ellipsis" v-else>
                      向主演打赏了一个{{ item.total_money / 100 }}元的红包
                    </p>
                  </div>
                </div>
              </div>
              <!-- 分享得红包 -->
              <div v-else-if="item.module == 'share_comment'" class="red-pack">
                <div class="red-pack-header">
                  <img
                    class="red-pack-img"
                    :src="imgPath + 'room/redpack_03.png'"
                  />
                  <div class="red-pack-title">
                    <p class="share_red_content ellipsis">
                      {{ item.nick }}分享后得到{{ item.money / 100 }}元的红包
                    </p>
                  </div>
                </div>
              </div>
              <!-- 邀请得红包 -->
              <div v-else-if="item.module == 'invite_comment'" class="red-pack">
                <div class="red-pack-header">
                  <img
                    class="red-pack-img"
                    :src="imgPath + 'room/redpack_03.png'"
                  />
                  <div class="red-pack-title">
                    <p class="share_red_content ellipsis">
                      {{ item.nick }}获得{{ item.money / 100 }}元的红包
                    </p>
                  </div>
                </div>
                <p class="caption">
                  <span>{{ item.invite_nick }}</span
                  >通过 <span>{{ item.nick }}</span
                  >分享的直播链接进入
                </p>
              </div>

              <!--礼物消息-->
              <div
                v-else-if="item.module == 'gift_comment'"
                class="comment-text"
              >
                <p>
                  赠送了：
                  <img :src="item.gift_pic_url" class="gift" />
                  x {{ item.gift_num ? item.gift_num : 1 }}
                </p>
              </div>

              <!--霸屏-->
              <div
                v-else-if="item.module == 'wall_comment'"
                class="comment-text wall_comment"
              >
                <p v-if="item.content">
                  <span>重金霸屏{{ 5 * item.pay_level }}秒：</span>
                  {{ item.content }}
                </p>
                <div
                  v-if="item.pic_url && item.content"
                  style="height:10px"
                ></div>
                <img
                  v-if="item.pic_url"
                  class="contImg"
                  :src="item.pic_url"
                  @click="preview(item.pic_url)"
                />
              </div>

              <!--卡券-->
              <div
                v-else-if="item.module == 'coupon_comment'"
                class="comment-text quanBox"
                :style="'background-image:url(' + imgPath + 'room/quan-bg.png)'"
              >
                <div class="quan">
                  <div class="quantype" v-if="item.coupon_type == 'discount'">
                    折扣券
                  </div>
                  <div class="quantype" v-else-if="item.coupon_type == 'money'">
                    代金券
                  </div>
                  <div class="quantype" v-else-if="item.coupon_type == 'gift'">
                    礼品券
                  </div>
                  <div
                    class="quantype"
                    v-else-if="item.coupon_type == 'coupon'"
                  >
                    优惠券
                  </div>
                  <div class="quantype" v-else>门票券</div>
                  <p>
                    <span>{{ item.coupon_title }}</span>
                  </p>
                </div>
                <p class="caption" v-if="item.invite_nick">
                  <span>{{ item.invite_nick }}</span
                  >通过 <span>{{ item.nick }}</span
                  >分享的直播链接进入
                </p>
              </div>
              <!-- 红包雨的消息 -->
              <!-- <div v-else-if="item.module == 'redrain_comment'">
              </div>-->
            </div>
          </div>
          <div style="height: 10px;"></div>
        </template>
        <div class="loading" v-show="loadingShow">
          <van-loading color="black" />
        </div>
        <div v-if="!isThreeScreen" style="height:40px;width: 100%;text-align: center;"></div>
        <div v-if="!livetimeend && directStatus !='running'" style="height: 84px;"></div>
        <div v-if="noticeObj.open && isNoitceTopShow" style="height: 36px;"></div>

        <!-- </div> -->
      </van-pull-refresh>
    </div>

    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[0]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[0]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[1]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[2]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[2]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[3]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[3]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[4]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[4]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[5]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[5]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[6]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[6]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[7]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[7]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[8]" />
    </div>
    <div
      class="zan-box"
      v-for="(n, index) in lovestyle[8]"
      :style="n"
      :key="index"
    >
      <img class="zan-img" :src="zanimg[9]" />
    </div>

    <!--未读新消息消息-->
    <div class="unreadMsg" v-show="isShowUnReadMsg" @click="unReadMsgAction()">
      <img :src="imgPath + 'room/unreadMsg.png'" width="8px" height="8px" />
      <span style="padding: 0 0 0 5px;">{{ unReadMsgNum }}条新消息</span>
    </div>

    <!--点赞图片box-->
    <div class="zanBox" v-if="numList.length">
      <div class="num" v-for="(item, index) in numList" :key="index">
        <template v-for="item1 in item">
          <img :src="item1" alt="index" :key="item1" />
        </template>
      </div>
    </div>

    <!--微信二维码-->
    <van-popup v-model="showCode" class="codebox">
      <div>
        <p class="title">长按关注公众号</p>
        <img
          src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/code/code.jpg"
          class="code stop"
        />
        <p class="text">关注二维码，了解最新直播信息</p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Toast } from "vant";
import { Waterfall, List, Popup, Loading, Swipe, SwipeItem,NoticeBar } from "vant";
Vue.use(List);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Loading);
Vue.use(Swipe).use(SwipeItem);
import tool from "../../../kits/Tools.js";
import Bus from "../../../kits/eventBus.js";
import Vue from "vue";
import { mapGetters } from "vuex";

export default {
  directives: {
    WaterfallLower: Waterfall("lower"),
    WaterfallUpper: Waterfall("upper"),
  },
  computed: {
    ...mapGetters({
      userConfig: "dsInfo/getUserConfig",
      businessConfigs:"dsInfo/getBusinessConfigs"
    })
  },
  data() {
    return {
      tid: 0,
      styleType: 1,
      chatRecord: [],
      adImages: [],
      unReadMsgNum: 0, //未读消息条数
      timer1: {},
      enterNames: [],
      enterSales: [],
      enterMoney: [],
      isLoading: false,
      loadingShow: false,
      hostId: "-1",
      isShowAd: false,
      timer: "",
      ds_id: "",
      isShowUnReadMsg: false,
      isOnscroll: false,
      homeRodRedBagStyle: {}, //抢红包
      homeRobRedBagListStyle: {}, //红包列表
      redBaglistData: {},
      robed: false,
      welcomeTimer: null,
      lovestyle: [[], [], [], [], [], [], [], [], []],
      personIndex: 0,
      productIndex: 0,
      moneyIndex: 0,
      isWeixin: true,
      numList: [],
      numTimer: "",
      zanIndex: 0,
      zanNum: [],
      zanimgIndex: 0,
      zanimg: [],
      chongbai: "",
      dianzan: "",
      lianji: "",
      lihai: "",
      haipi: "",
      kuai: "",
      hundred: "",
      bang: "",
      caicai: "",
      siyi: "",
      reviewWrap: [],
      reviewTimer: "",
      showH: false,
      fristMsgId: "",
      quick_id: "",
      total_like: 0,
      loaded: false,
      zanAmount: 0,
      likeTimer: "",
      IMlogin: false,
      imgPath: "",
      intervalTime: 0,
      prohibit: false,
      subscribed: false,
      showCode: false,
      subscribedText: "subscribed",
      days: "00",
      hours: "00",
      minites: "00",
      seconds: "00",
      timer: "",
      livetimeend: false,
      scrollTop: 0,
      scrolltimer: null,
      loadCommenting: false,
      isIOS: false,
      unReadMsgPointShow: false,
      unReadMsgData: null,
      showUnReadView: false,
      diff:0,
      startY:0,
      isNoitceTopShow:true,
      noticetimer:null
    };
  },
  props: [
    "fans_id",
    "initData",
    "fullscr",
    "forbid",
    "totalLike",
    "currentMid",
    "mid",
    "dynamicData",
    "directStatus",
    "startTime",
    "playerStatus",
    "linkType",
    "openWx_follow",
    "showTeacherBtn",
    "noticeObj",
    "isshowCart",
    "channel_code",
    "isLoadHistory",
    "dsId",
    "isThreeScreen"
  ],
  watch: {
    isLoadHistory:{
      handler: function(newVal, oldVal) {
          if (this.isLoadHistory) {
              this.initCommentData()
          }
        },
        immediate: true
    },
    currentMid() {
      if (!this.loaded && this.currentMid == this.mid) {
        this.beforeInit();
      }
      if (this.currentMid == this.mid) {
        this.openReview();
        this.prohibit = false;
      } else {
        clearInterval(this.reviewTimer);
        this.prohibit = true;
      }
    },
    fullscr(o, n) {
      if (n) {
        clearInterval(this.reviewTimer);
      } else {
        this.openReview();
      }
    },
    totalLike(curVal, oldVal) {
      this.total_like = curVal;
    },
    noticeObj(newVal,oldVal) {
      if (newVal.open) {
        let index_tmp = this.reviewWrap.findIndex(item => item.module == "notice")
        if (index_tmp != -1) {
            this.reviewWrap.splice(index_tmp, 1);
        }
         this.reviewWrap.unshift({
            module: "notice",
            content:newVal.content,
            nick:"公告",
            header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png",
          });
          this.chatRecord = this.reviewWrap.concat().reverse();
          this.isNoitceTopShow = true;
          if (this.noticetimer) {
             clearTimeout(this.noticetimer);
             this.noticetimer = null;
          }
          if (newVal.time !=-1) {
              this.noticetimer = setTimeout(() => {
                this.isNoitceTopShow = false
            },parseInt(newVal.time || 0)*1000);
          }
      } else {
         if (this.noticetimer) {
             clearTimeout(this.noticetimer);
             this.noticetimer = null;
        }
         let index_tmp = this.reviewWrap.findIndex(item => item.module == "notice")
         if (index_tmp != -1) {
            this.reviewWrap.splice(index_tmp, 1);
        }
         this.chatRecord = this.reviewWrap.concat().reverse();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.reviewTimer);
  },
  mounted() {
    var that = this;
    this.isWeixin = tool.isWeixin();
    this.ds_id = tool.getDs_id();

    this.tid = tool.getQueryString("tid");
    this.subscribedText += this.ds_id;
    this.subscribed = localStorage.getItem('"' + this.subscribedText + '"');
    console.log(this.subscribedText + "____" + this.subscribed);
    this.imgPath = tool.imgPath();
    this.getImg();
    this.timeSwitch();
    this.isIOS = tool.checkPhoneType() == 2;

    //监听消息
    Bus.$on("messageisCheck", function(json) {
      that.textComment(json);
    });
  },
  methods: {
    copyTextTap(text){
        let reg=/\<a(.*?)\>(\S*)\<\/a>/
        let resultArr = text.match(reg) 
        if(resultArr && resultArr[2]){
          text = resultArr[2]
        }
        var oInput = document.createElement('input'); //创建一个隐藏input（重要！）
        oInput.value = text;    //赋值
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        oInput.style.display = 'none';
        document.body.removeChild(oInput)
        Toast("复制成功");
    },
    onLinkCLick() {
      this.$emit("sendApplyLink");
    },
    onShowTeacherList() {
      this.unReadMsgPointShow = false;
      this.$emit("onShowTeacherList");
    },
    onShowGoodsList() {
      this.$emit("onShowGoodsList");
    },
    onLinkEndClick() {
      this.$emit("sendEndLink");
    },
    getImg() {
      var path = this.imgPath;
      for (let i = 0; i < 10; i++) {
        this.zanNum.push(path + "zan/" + i + ".png");
        this.zanimg.push(path + "zan/zanimg" + i + ".png");
      }
      this.chongbai = path + "zan/chongbai.png";
      this.dianzan = path + "zan/dianzan.png";
      this.lianji = path + "zan/lianji.png";
      this.lihai = path + "zan/lihai.png";
      this.haipi = path + "zan/haipi.png";
      this.kuai = path + "zan/kuai.png";
      this.hundred = path + "zan/hundred.png";
      this.bang = path + "zan/bang.png";
      this.caicai = path + "zan/caicai.png";
      this.siyi = path + "zan/siyi.png";
    },
    chatScroll(){//滚动到底部
        // var h = document.getElementById("ChatRoomContent").scrollHeight;
        // this.scrollTop = document.getElementById("ChatRoomContent").scrollTop;
        // if (h - this.scrollTop > 800) {
        //   this.isOnscroll = true;
        // } else {
        //   this.isOnscroll = false;
        //   this.isShowUnReadMsg = false;
        //   this.unReadMsgNum = 0;
        // }
    },
    chatTouchstart(e){
        this.diff = 0
        var touch = e.touches[0];
        this.startY = touch.pageY;
    },
    chatTouchmove(e){
        var touch = e.touches[0];
        let endY = touch.pageY;
        this.diff = endY - this.startY;
    },
    chatTouchend(e){
        if (Math.abs(this.diff) > 60 && !this.businessConfigs.student_message_auto_scroll) {
             console.log("====>",this.diff,"isOnscroll",this.isOnscroll)
             if (this.diff> 0) {
               this.isOnscroll = true;
             }else{
                let last_mouseWheel_scrollTop = document.getElementById("ChatRoomContent").scrollTop;
                var h = document.getElementById("ChatRoomContent").scrollHeight;
                var windowHeight = document.getElementById("ChatRoomContent").clientHeight;
                if (h <= (last_mouseWheel_scrollTop + windowHeight + 10)) {
                  this.isOnscroll = false;
                  this.isShowUnReadMsg = false;
                  this.unReadMsgNum = 0;
                }
            }      
          }
    },
    beforeInit() {
      if (navigator.userAgent.indexOf("iPhone") > -1) {
        this.isIOS = true;
      }
      this.loaded = true;
      //this.inputblur();
      this.init();
    },
    removePL() {
      var scrollTop;
      if (document.getElementById("ChatRoomContent")) {
        scrollTop = document.getElementById("ChatRoomContent").scrollTop;
      }
      if (
        scrollTop < 2000 &&
        160 >= this.reviewWrap.length &&
        this.reviewWrap.length >= 60
      ) {
        this.reviewWrap.splice(30, this.reviewWrap.length);
        this.fristMsgId = this.reviewWrap[this.reviewWrap.length - 1]._id;
      } else if (
        2000 < scrollTop &&
        scrollTop < 5000 &&
        this.reviewWrap.length >= 120
      ) {
        this.reviewWrap.splice(60, this.reviewWrap.length);
        this.fristMsgId = this.reviewWrap[this.reviewWrap.length - 1]._id;
      } else {
      }
    },
    init() {
      this.total_like = this.totalLike;
      //功能解析
      for (var i = 0; i < this.initData.ds_func.length; i++) {
        var j = this.initData.ds_func[i];

        // if(j.module == "ad" && j.enabled == "yes") { //广告功能
        // 	this.isShowAd = true;
        // 	this.adImages = this.adImages.concat(j.params);
        // 	console.log(this.adImages)
        // } else

        if (j.module == "master") {
          //主持人功能
          this.hostId = j.params.fans_id;
        }
      }
      if (this.initData.direct_seeding.style != 0) {
        this.styleType = this.initData.direct_seeding.style;
      }
    },
    initCommentData() {
      var that = this;
      that.loadingShow = true;
      var url = tool.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.dsId + "&_id=" + this.fristMsgId;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      this.axios
        .post(url, option,{ timeout: window.isExceptionMode ? 1000 : 10000 })
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            var dataClip = [];
            data.data.forEach(function(item) {
              if (item.module != "redrain_comment") {
                if(item.channel_code) {
                    let channel_code_arr =  JSON.parse(item.channel_code)
                   if (channel_code_arr.indexOf(that.channel_code) > -1) {
                    dataClip.push(item);
                   }
                }else {
                  dataClip.push(item);  
                }
              }
            });

            if (that.noticeObj.open) {
                dataClip.unshift({
                  module: "notice",
                  content: that.noticeObj.content,
                  nick:"公告",
                  header: "https://shanhu-live-1317978474.cos.ap-guangzhou.myqcloud.com/web/wx-user/img/ico_gonggao%402x.png",
                });
               if (that.noticeObj.time != -1) {
                  that.noticetimer = setTimeout(() => {
                    that.isNoitceTopShow = false
                },parseInt(that.noticeObj.time || 0)*1000);
               }
            }

            that.reviewWrap = that.reviewWrap.concat(dataClip);
            that.chatRecord = that.reviewWrap.concat().reverse();

            setTimeout(function() {
              document.getElementById(
                "ChatRoomContent"
              ).scrollTop = document.getElementById(
                "ChatRoomContent"
              ).scrollHeight;
            }, 500);

            setTimeout(function() {
              that.loadingShow = false;
              if (!dataClip.length) {
                // that.isLoading = true;
              } else {
                that.fristMsgId =
                  that.reviewWrap[that.reviewWrap.length - 1]._id;
                that.isLoading = false;
                console.log("数据还有加载中");
              }
              that.isLoading = false;
            }, 500);
          } else {
            console.log(data.message);
          }
        })
        .catch(function(res) {
          // that.waterfall_disabled = true;
          that.isLoading = false;
          that.loadingShow = false;
          console.log(res);
        });
    },
    loadMore() {
      var that = this;
      console.log("加载数据中loadMore");
      console.log(this.isLoading);
      // if(!this.waterfall_disabled){
      // 	return;
      // }
      console.log("加载数据中loadMore----bing");
      // that.loadCommenting = true;
      // this.waterfall_disabled = true;
      that.loadingShow = true;
      var url = tool.baseUrl2() + "/comment/index/listsForStudent";
      var option = "ds_id=" + this.ds_id + "&_id=" + this.fristMsgId;

      if (this.tid) {
        option = option + "&tid=" + this.tid;
      }

      this.axios
        .post(url, option,{ timeout: window.isExceptionMode ? 1000 : 10000 })
        .then(function(res) {
          that.loadingShow = false;
          that.loadCommenting = false;
          var data = res.data;
          if (data.code == "200") {
            if (data.data.length == 0) {
              that.isLoading = false;
              Toast("没有数据了");
              return;
            }
            var dataClip = [];
            data.data.forEach(function(item) {
              if (item.module != "redrain_comment") {
                if(item.channel_code) {
                    let channel_code_arr =  JSON.parse(item.channel_code)
                   if (channel_code_arr.indexOf(that.channel_code) > -1) {
                    dataClip.push(item);
                   }
                }else {
                  dataClip.push(item);  
                }
              }
            });
            that.reviewWrap = that.reviewWrap.concat(dataClip);
            that.chatRecord = that.reviewWrap.concat().reverse();
            
            if (that.chatRecord.length > 300) {
              that.chatRecord.splice(0,50);
            }

            if (!dataClip.length) {
              // that.waterfall_disabled = true;
              // return;
            } else {
              that.fristMsgId = that.reviewWrap[that.reviewWrap.length - 1]._id;
              console.log("还可以加载中");
            }
            that.isLoading = false;
          } else {
            console.log(data.message);
          }
          that.isLoading = false;
        })
        .catch(function(res) {
          that.loadingShow = false;
          that.isLoading = false;
          // that.loadCommenting = false;
          console.log(res);
        });
    },
    personenter(name) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      if (this.intervalTime == 0) {
        this.enterNames.push(name);
      } else {
        return false;
      }
      var time = Math.random() * 300 + 100;
      console.log("飘窗进入");
      this.intervalTime = 1;
      setTimeout(function() {
        that.intervalTime = 0;
      }, time);
      setTimeout(function() {
        that.personIndex++;
      }, 1500);
    },
    productEnter(name, num) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      this.enterSales.push({ nick: name, num: num });
      setTimeout(function() {
        that.productIndex++;
      }, 6000);
    },
    moneyEnter(name, money) {
      var that = this;
      if (this.prohibit || this.forbid) {
        return;
      }
      this.enterMoney.push({ nick: name, money: money });
      setTimeout(function() {
        that.moneyIndex++;
      }, 6000);
    },
    openReview() {
      console.log("openRe");
      var that = this;
      this.reviewTimer = setInterval(function() {
        that.removePL();
        that.chatRecord = that.reviewWrap.concat().reverse();
      }, 2000);
    },
    addLikeNum(item) {
      var url,
        option,
        that = this;
      if (item) {
        url = tool.baseUrl2() + "/comment/index/addLikeNum";
        option = "&ds_id=" + this.ds_id + "&id=" + item._id;
        this.sendLike(url, option);
      } else {
        this.zanAmount++;
        this.total_like++;
        url = tool.baseUrl2() + "/init/addAgree";
        option = "ds_id=" + this.ds_id + "&num=" + this.zanAmount;
        clearTimeout(this.likeTimer);
        this.likeTimer = setTimeout(function() {
          that.sendLike(url, option);
        }, 1000);
      }
    },
    sendLike(url, option) {
      var that = this;
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          console.log(data);
          that.zanAmount = 0;
        })
        .catch(function(res) {
          console.log("错误" + res.data);
        });
    },
    reply(item) {
      //回复
      Bus.$emit("replying", item);
    },
    robRedBagAction(item) {
      //抢红包
      this.$emit("robRedBagAction", item);
    },
    onAdClicked(link) {
      if (link != "") {
        window.location.href = link;
      }
    },
    //未读消息滚动到顶部
    unReadMsgAction() {
      this.unReadMsgNum = 0;
      this.isOnscroll = false
      this.isShowUnReadMsg = false;
      document.getElementById(
        "ChatRoomContent"
      ).scrollTop = document.getElementById("ChatRoomContent").scrollHeight;
    },
    preview(url) {
      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    subscribe() {
      var that = this;
      var url = tool.baseUrl2() + "/api/ds/subscribe";
      var option =
        "subscribe_id=" +
        this.ds_id +
        "&fans_id=" +
        this.fans_id +
        "&type=ds_room";
      this.axios
        .post(url, option)
        .then(function(res) {
          var data = res.data;
          if (data.code == "200") {
            Toast(data.data);
            that.subscribed = true;
            localStorage.setItem(
              '"' + that.subscribedText + '"',
              that.subscribed
            );
          } else if (data.code == "401") {
            Toast(data.message);
            setTimeout(function() {
              that.showCode = true;
            }, 1000);
          } else {
            Toast(data.message);
          }
        })
        .catch(function(res) {
          console.log(res);
        });
    },
    redpacket(json) {
      for (var i = 0, len = this.reviewWrap.length; i < len; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          if (item.sublist) {
            item.sublist.push(json);
          } else {
            this.$set(item, "sublist", [json]);
          }
          break;
        }
      }
    },
    addLikeNumIm(json) {
      if (json._id) {
        for (let i = 0; i < this.reviewWrap.length; i++) {
          var item = this.reviewWrap[i];
          if (item._id == json._id) {
            item.like_num += 1;
            break;
          }
        }
      }
      this.total_like += json.like_num;
    },
    deleteComment(json) {
      console.log(this.reviewWrap);
      for (let i = 0; i < this.reviewWrap.length; i++) {
        var item = this.reviewWrap[i];
        if (item._id == json._id) {
          this.reviewWrap.splice(i, 1);
          break;
        }
      }
    },
    textComment(json) {
      //过滤重复消息
      if (json.business_id) {
        console.log("子评论");
        for (var i = 0, len = this.reviewWrap.length; i < len; i++) {
          var item = this.reviewWrap[i];
          if (item._id == json._id) {
            if (item.sublist) {
              if (json.content && json.content != "null") {
                json.content = json.content
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">");
              }
              item.sublist.push(json);
            } else {
              if (json.content && json.content != "null") {
                json.content = json.content
                  .replace(/&lt;/g, "<")
                  .replace(/&gt;/g, ">");
              }
              this.$set(item, "sublist", [json]);
            }
            break;
          }
        }
      } else {
        //先审后发处理
        let hasKey = this.reviewWrap.find((item1) => {
          return item1.key == json.key && item1.key;
        });
        if (hasKey) {
          hasKey._id = json._id
          return;
        }
        //未读消息处理
        if (this.isOnscroll) {
          this.isShowUnReadMsg = true;
          this.unReadMsgNum = this.unReadMsgNum + 1;
        } else {
          this.isShowUnReadMsg = false;
          this.unReadMsgNum = 0;
        }
        if (json.content && json.content != "null") {
          json.content = json.content
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");
        }

        this.reviewWrap.unshift(json);
       
        //评论超过1千删除200
        if (this.reviewWrap.length > 400) {
           this.reviewWrap = this.reviewWrap.slice(0,250)
        }
        this.chatRecord = this.reviewWrap.concat().reverse();
        
        //一秒内收到多条消息时，只刷新一次
        this.msgScrollBottom();
      }
    },
    msgScrollBottom() {
      // var h = document.getElementById("ChatRoomContent").scrollHeight;
      // var self = this;
      // if (this.scrolltimer == null) {
      //   this.scrolltimer = setTimeout(function() {
      //     if (h - self.scrollTop < 800) {
      //       document.getElementById(
      //         "ChatRoomContent"
      //       ).scrollTop = document.getElementById(
      //         "ChatRoomContent"
      //       ).scrollHeight;
      //     }
      //     self.scrolltimer = null;
      //   }, 500);
      // }

     if (!this.isOnscroll) {
       setTimeout(() => {
             document.getElementById(
              "ChatRoomContent"
            ).scrollTop = document.getElementById(
              "ChatRoomContent"
            ).scrollHeight;
       }, 0);  
     }
    },
    giftComment(json) {
      this.reviewWrap.unshift(json);
    },
    riseData(json) {
      var that = this;
      this.$emit("personnum", json.view_num);
      if (this.total_like < json.like_num) {
        this.total_like = json.like_num;
      }
      if (!this.welcomeTimer) {
        var count = json.personData.length;
        this.welcomeTimer = setInterval(function() {
          if (json.personData.length == 0) {
            clearInterval(that.welcomeTimer);
            that.welcomeTimer = null;
          } else {
            that.personenter(json.personData.shift().nick);
            that.$emit("personnum", 0);
          }
        }, 10000 / count);
      }
    },
    addReviewWrap(json) {
      this.reviewWrap.unshift(json);
    },
    zan(ev, item) {
      var that = this,
        arr = [];
      clearTimeout(this.timer);
      clearTimeout(this.numTimer);
      if (item) {
        this.addLikeNum(item);
      } else {
        this.addLikeNum();
      }

      function zann(ev) {
        var index = Math.ceil(Math.random() * 9) - 1;
        that.lovestyle[index].push({
          left: ev.clientX - 10 + "px",
          top: ev.clientY - 30 + "px",
        });
        setTimeout(function() {
          that.lovestyle[index].shift();
        }, 3000);
      }
      zann(ev);
      this.zanIndex++;
      console.log(this.zanIndex);
      if (this.zanIndex < 10) {
        arr.push(this.zanNum[this.zanIndex]);
        if (this.zanIndex == 1) {
          arr.push(this.dianzan);
        } else {
          arr.push(this.lianji);
        }
      } else if (this.zanIndex >= 10 && this.zanIndex < 100) {
        if (this.zanIndex == 10) {
          arr.push(this.lihai);
        } else if (this.zanIndex == 20) {
          arr.push(this.chongbai);
        } else if (this.zanIndex == 30) {
          arr.push(this.siyi);
        } else if (this.zanIndex == 50) {
          arr.push(this.kuai);
        } else if (this.zanIndex == 80) {
          arr.push(this.caicai);
        } else {
          arr.push(this.zanNum[this.zanIndex.toString().substr(0, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(1, 1)]);
          arr.push(this.lianji);
        }
      } else if (this.zanIndex >= 100 && this.zanIndex < 200) {
        if (this.zanIndex == 100) {
          arr.push(this.hundred);
        } else if (this.zanIndex == 150) {
          arr.push(this.haipi);
        } else {
          arr.push(this.zanNum[this.zanIndex.toString().substr(0, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(1, 1)]);
          arr.push(this.zanNum[this.zanIndex.toString().substr(2, 1)]);
          arr.push(this.lianji);
        }
      } else {
        arr.push(this.bang);
      }
      this.numList.push(arr);
      this.numTimer = setTimeout(function() {
        that.zanIndex = 0;
        that.numList = [];
      }, 1000);

      this.zanimgIndex = parseInt(Math.random() * 10) - 1;
    },
    timeSwitch() {
      var now = new Date().getTime();
      if (!this.startTime) {
        return;
      }
      var start = new Date(this.startTime.replace(/-/g, "/")).getTime();
      if (now < start) {
        this.countDown(parseInt((start - now) / 1000));
        //console.log('未开始');
      } else {
        this.livetimeend = true;
      }
    },
    countDown(times) {
      var that = this;
      clearInterval(this.timer);
      this.timer = setInterval(function() {
        if (times != 0) {
          times--;
          that.days = Math.floor(times / 86400);
          that.hours = tool.two(Math.floor((times % 86400) / 3600));
          that.minites = tool.two(Math.floor((times % 3600) / 60));
          that.seconds = tool.two(Math.floor(times % 60));
        } else {
          that.livetimeend = true;
          clearInterval(that.timer);
        }
      }, 1000);
    },
    receivedMsg(json) {
      this.unReadMsgPointShow = true;
    },
    showUnReadViewFunc(json) {
      this.unReadMsgData = json;
      this.showUnReadView = true;
      setTimeout(() => {
        this.showUnReadView = false;
      }, 4500);
    },
    changeNick(nick) {
      if (nick) {
        // var value = nick.replace(/[^0-9]/gi, "");
        // if (value.length == 11) {
        //   //3.截取所有数字，并用*替换4，4
        //   var phNum = nick.replace(/[^0-9]/gi, "");
        //   var phnumAfter = phNum.substr(0, 3) + "****" + phNum.substr(7);
        //   return nick.replace(phNum, phnumAfter);
        // }
        return nick.replace(/(\d{3})\d{4}(\d{4})/g, "$1****$2");
      }
      return "";
    },
  },
};
</script>

<style scoped>

.right-func-box{
  z-index: 3000;
  position: absolute;
  bottom: 60px;
  right: 10px;
  width: 50px;
  border-radius: 20px;
  text-align: center;
}

.link-btn {
  z-index: 3000;
  /* position: absolute; */
  bottom: 140px;
  right: 10px;
  width: 50px;
  height: 70px;
  border-radius: 20px;
  text-align: center;
}



.link-btn img {
  width: 40px;
  height: 40px;
}

.link-btn span {
  font-size: 12px;
}

.zixun-btn span {
  font-size: 12px;
}

.zixun-btn {
  z-index: 3000;
  /* position: absolute; */
  bottom: 60px;
  right: 10px;
  width: 50px;
  height: 70px;
  border-radius: 20px;
  text-align: center;
}

.zixun-btn img {
  width: 40px;
  height: 40px;
}

.zixun-btn .unReadMsgPoint {
  position: absolute;
  bottom: 54px;
  right: 2px;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: red;
  border-radius: 8px;
}



.shopping-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(0, 0, 0, .7);
}
.shopping-dialog img {
  width: 300px;
  height: 300px;
}

#ChatRoomContent {
  height: 100%;
  overflow: scroll;
  scroll-behavior: smooth;
}

.ChatRoom-body {
  background: #eee;
}

.header-img {
  height: 34px;
  width: 34px;
  margin-top: 15px;
  margin-left: 10px;
  float: left;
  border-radius: 15px;
}

.van-swipe__track {
  height: 50px;
}

.van-swipe__indicators .van-swipe__indicator--active {
  background-color: red;
}

.van-swipe__indicators {
  bottom: 4px;
}

.none {
  display: none;
}

.loading {
  height: 30px;
  width: 30px;
  margin: 10px auto;
}

.header {
  position: relative;
  padding: 0 10px 0 60px;
}

.msg_header {
  position: absolute;
  top: 12px;
  left: 12px;
  height: 36px;
  width: 36px;
}

.msg_header .headimg {
  width: 36px;
  height: 36px;
  border-radius: 30px;
  border-color: #ffeb12;
  position: absolute;
}

.type .msg_header .headimg {
  border-color: #ff0000;
}

.banner {
  height: 50px;
  overflow: hidden;
  width: 100%;
}

.banner a {
  width: 100%;
  height: 100%;
  display: block;
}

.banner img {
  width: 100%;
  height: 50px;
  display: block;
}

.ChatRoom-header {
  background: #e8e8e8;
  height: 44px;
  overflow: hidden;
  line-height: 44px;
  color: #343434;
}

.ChatRoom-header.fixed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1300;
}

.ChatRoom-header.type {
  color: #ff0000;
}

.total_comment {
  margin-left: 10px;
  float: left;
}

.total_like img {
  height: 25px;
  width: 25px;
  vertical-align: middle;
}

.total_like {
  margin-right: 10px;
  float: right;
}

.total-like-num {
  position: relative;
  vertical-align: middle;
  background: #343434;
  padding: 4px;
  margin-right: 4px;
  border-radius: 5px;
  color: white;
  min-width: 18px;
  display: inline-block;
  line-height: 18px;
  text-align: center;
}
.type .total-like-num {
  background: #ff0000;
}
.jiantou {
  position: absolute;
  top: 18px;
  height: 10px;
  width: 10px;
  right: 28px;
  background: #343434;
  color: #fff;
  transform: rotate(45deg);
  z-index: 0;
}

.type .jiantou {
  background: #ff0000;
}

.cell {
}

.comment_cell {
  position: relative;
  padding-bottom: 15px;
}

.comment_cell .header img {
  max-width: 300%;
}

.span-name {
  float: left;
  margin-top: 22px;
  margin-left: 12px;
  font-size: 14px;
  color: #666666;
}

.span-time {
  margin-top: 22px;
  margin-left: 12px;
  float: left;
  font-size: 12px;
  color: #cccccc;
}

.span-like-num {
  margin-top: 22px;
  float: right;
  font-size: 12px;
  margin-right: 15px;
  color: #cccccc;
}

.span-like-num img {
  margin-right: 3px;
  height: 15px;
  width: 14px;
  vertical-align: bottom;
}

.wall_comment {
  border: 1px solid #e2b766;
}

.wall_comment span {
  color: #d4aa51;
  font-weight: bold;
}

.comment-text {
  word-wrap: break-word;
  font-size: 15px;
  margin: 8px 30px 0 60px;
  color: #333;
  background-color: #fff;
  border-radius: 5px;
  padding: 5px;
  line-height: 19px;
  display: inline-block;
  max-width: 64%;
  position: relative;
}

.comment-text p .gift {
  width: 30px;
  vertical-align: middle;
}

.comment-floor {
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 13px;
  margin-right: 15px;
}

.red-pack {
  margin-left: 52px;
  margin-top: 5px;
  width: 78%;
  overflow: hidden;
  border-radius: 5px;
}
.caption {
  background: #fff;
  padding: 5px;
  line-height: 20px;
  font-size: 14px;
}
.caption span {
  color: #f99c3a;
}
.red-pack-header {
  background-color: #f99c3a;
  height: 65px;
}

.red-pack-header-radius {
  border-radius: 4px 4px 0px 0px;
}

.red-pack-img {
  float: left;
  height: 40px;
  width: 38px;
  margin-top: 13px;
  margin-left: 15px;
}

.red-pack-title {
  margin-top: 0px;
  color: white;
  padding-top: 15px;
  padding-right: 10px;
  font-size: 13px;
  margin-left: 60px;
  white-space: nowrap;
}

.red-pack-desc {
  font-size: 10px;
  margin-top: 3px;
  padding-right: 5px;
}

.red-pack-body {
  background-color: #f5f5f5;
  border-radius: 0px 0px 4px 4px;
}

.red-pack-item {
  height: 38px;
  line-height: 38px;
  font-size: 12px;
  margin-left: 15px;
}

.red-pack-item-name {
  color: #999999;
  font-size: 12px;
  max-width: 170px;
  overflow: hidden;
  height: 38px;
}

.red-pack-item-text {
  color: #555555;
  font-size: 12px;
}

.red-pack-item-money {
  color: #f99c3a;
  font-size: 12px;
}

.red-pack-item-time {
  float: right;
  font-size: 11px;
  color: #ccc;
  margin-right: 10px;
}

.share_red_content {
  padding-top: 10px;
}

.total-zan {
  position: relative;
  display: inline-block;
}

.zan-box {
  position: fixed;
  z-index: 10000;
  height: 20px;
  width: 20px;
}

.zan-box .zan-img:nth-child(3n) {
  position: absolute;
  opacity: 0;
  height: 20px;
  width: 20px;
  animation: zanA 2s;
}

.zan-img:nth-child(3n + 1) {
  position: absolute;
  opacity: 0;
  height: 20px;
  width: 20px;
  animation: zanB 2s;
}

.zan-img:nth-child(3n + 2) {
  position: absolute;
  opacity: 0;
  height: 20px;
  width: 20px;
  animation: zanC 2s;
}

@keyframes zanA {
  0% {
    top: 0px;
    left: 0px;
    width: 25px;
    opacity: 1;
  }
  33% {
    top: -66px;
    left: 20px;
  }
  66% {
    top: -133px;
    left: -20px;
  }
  100% {
    top: -200px;
    left: 20px;
    width: 50px;
    opacity: 0;
    display: none;
  }
}

@keyframes zanB {
  0% {
    top: 0px;
    left: 0px;
    width: 25px;
    opacity: 1;
  }
  100% {
    top: -200px;
    left: 0px;
    width: 50px;
    opacity: 0;
    display: none;
  }
}

@keyframes zanC {
  0% {
    top: 0px;
    left: 0px;
    width: 25px;
    opacity: 1;
  }
  100% {
    top: -300px;
    left: 20px;
    width: 50px;
    opacity: 0;
    display: none;
  }
}

.entenview {
  position: fixed;
  margin-left: 100%;
  z-index: 2000;
  background-repeat: no-repeat;
  background-position: left center;
  height: 44px;
  line-height: 54px;
  color: #ffde00;
  width: 100%;
  background-size: auto 44px;
  padding-left: 70px;
  animation: float 1.5s linear;
  top: 60vh;
}
.entenview1 {
  background-image: url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_03.png);
}
.entenview2 {
  background-image: url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_01.png);
}
.entenview3 {
  background-image: url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/room/feiru_02.png);
}
.entenview2,
.entenview3 {
  animation: float 6s linear;
  line-height: 40px;
  width: 216px;
  padding-left: 36px;
  color: #fff;
  font-size: 11px;
}

@keyframes float {
  0% {
    margin-left: 100%;
  }

  30% {
    margin-left: 10px;
  }

  70% {
    margin-left: 10px;
  }

  100% {
    margin-left: -100%;
  }
}

.van-button--normal {
  width: 60px;
  padding: 0;
  text-align: center;
}

.hostman {
  background: #fff1d7;
}

.hostman .headimg {
  border-width: 1px;
  border-style: solid;
}

.rank {
  position: absolute;
  top: 28px;
  width: 55px;
  left: -8.5px;
}

.occupyRank {
  position: absolute;
  top: -1px;
  width: 52px;
  left: -8px;
}

.msg_conent {
  background-color: white;
  margin: 15px 36px 15px 56px;
  padding: 12px 15px;
  border: 1px solid #a47214;
  border-radius: 10px;
  word-wrap: break-word;
}

.contImg {
  display: block;
}

.nameTime {
  padding-top: 12px;
}

.floor_name {
  width: 100%;
  height: 20px;
}

.floor_name span {
  float: left;
}

.nickname {
  color: #222;
  padding-left: 4px;
  display: inline-block;
}

.time {
  font-size: 12px;
  height: 16px;
  display: block;
}

.tools {
  position: absolute;
  top: 12px;
  right: 0;
}

.zanbar {
  float: right;
  margin-right: 12px;
  color: #343434;
}

.type .zanbar {
  color: #ff0000;
}

.zanbar img {
  width: 14px;
  vertical-align: middle;
}

.zanbar span {
  vertical-align: middle;
  font-size: 12px;
}

.xinxin1 {
  position: absolute;
  top: 58px;
  left: 56px;
  width: 30px;
}

.xinxin2 {
  position: absolute;
  right: 18px;
  top: 46px;
  width: 20px;
}

.xinxin3 {
  position: absolute;
  bottom: 10px;
  width: 50px;
  right: 20px;
}

.sublist {
  border-top: 1px solid #dbdbdb;
  font-size: 15px;
  background: #f5f5f5;
  margin: 10px -10px -10px;
  padding: 10px;
}

.sublist .title {
  color: #929292;
}

.sublist .title .time {
  font-size: 12px;
}

.unreadMsg {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translate(-50%, 0);
  color: #2e93ff;
  background-color: white;
  padding: 0 15px;
  border-radius: 15px;
  line-height: 30px;
  height: 30px;
}

.zanBox {
  position: fixed;
  top: 50%;
  left: 0;
  width: 80%;
  height: 100px;
  text-align: center;
  z-index: 1400;
}

.zanBox .num {
  width: 100%;
  animation: upover 0.75s linear;
  opacity: 0;
  position: absolute;
  top: 0;
}

.zanBox .num img {
  max-width: 100%;
}

.zanBox .num:nth-child(10n) img {
  height: 60px;
}

@keyframes upover {
  0% {
    opacity: 1;
  }
  100% {
    margin-top: -100px;
    opacity: 0;
  }
}
.quanBox {
  padding: 0;
  background-color: transparent;
}
.quanBox .caption {
  border-radius: 10px;
  position: relative;
}
.quan {
  padding: 0;
  background-color: #de3041;
  background-repeat: no-repeat;
  background-position: right 10px bottom;
  -webkit-background-size: 44px;
  background-size: 44px;
  color: #fff;
  height: 46px;
  padding: 10px;
  position: relative;
  border-radius: 10px;
}
.quan:after,
.quan:before {
  position: absolute;
  content: "";
  left: 37px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #eee;
  top: -8px;
}
.hostman .quan:after,
.hostman .quan:before {
  background: #fff1d7;
}
.quan:before {
  top: 60px;
}
.quan .quantype {
  display: table-cell;
  width: 26px;
  padding: 0 4px;
  line-height: 16px;
  color: #fbea00;
  font-size: 14px;
}
.quan p {
  border-left: 1px dashed #fff;
  padding: 0 0 0 18px;
  vertical-align: middle;
  display: table-cell;
  height: 46px;
}
.quan p span {
  display: inline-block;
  max-height: 46px;
  overflow: hidden;
}

.countDown {
  position: absolute;
  left: 0;
  right: 0;
  background: white;
  z-index: 2000;
  background: #fff;
  padding: 0px;
  padding-top: 10px;
  text-align: center;
  color: #333333;
}
.countDown h4 {
  line-height: 36px;
  border-bottom: 1px dashed #7d7d7d;
}
.countDown p {
  line-height: 36px;
}
.countDown .times {
  margin: 0 auto;
  width: 215px;
  height: 30px;
  padding: 0 8px 8px 8px;
  border-radius: 5px;
  /* background: linear-gradient(#407aff,#407aff 50%,#3170ff 50%,#3170ff 100%); */
  font-size: 25px;
  color: #666;
  display: -webkit-box;
  display: -moz-box;
  display: flex;
  overflow: hidden;
  position: relative;
}
.countDown .times:after {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 10px;
  /* background: linear-gradient(rgba(64,122,255,0.3),rgba(64,122,255,0)) */
}
.countDown li {
  border-left: 1px solid #fff;
  flex: 1;
  line-height: 30px;
}
.countDown li:first-child {
  border: none;
}
.countDown li span {
  font-size: 12px;
}
.subscribe {
  height: 30px;
  line-height: 30px;
  border: 1px solid #1483ff;
  border-radius: 30px;
  color: #1483ff;
  width: 100px;
  margin: 5px auto;
  text-align: center;
}

.unReadViewShowAni {
  animation: showUnReadView 0.5s ease-in, hiddenUnReadView 1s ease-out 3s;
  animation-fill-mode: forwards;
}

@keyframes showUnReadView {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes hiddenUnReadView {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.unReadView {
  position: absolute;
  bottom: 95px;
  right: 66px;
  min-width: 50px;
  max-width: 200px;
  min-height: 30px;
  background-color: white;
  z-index: 3000;
  border-radius: 5px;
  line-height: 30px;
  padding-left: 5px;
  padding-right: 5px;
  word-wrap: break-word;
  word-break: normal;
}

.unReadView .header {
  width: 26px;
  height: 26px;
  border-radius: 13px;
  vertical-align: -8px;
  padding-left: 0px;
  padding-right: 0px;
}

.unReadView .sanjiao {
  width: 0px;
  height: 0px;
  border-left: 10px solid #fff;
  border-bottom: 10px solid rgba(0, 0, 0, 0);
  border-top: 10px solid rgba(0, 0, 0, 0);
  position: absolute;
  bottom: 4px;
  right: -10px;
}

.zhuTeacher{
   display: inline-block;
   text-align: center;
   color: #ffffff;
   background: red;
   font-size: 10px;
   margin-left: 2px;
   line-height: 13px;
   padding:2px 3px;
   border-radius: 3px;
}
.copyText{
    position: absolute;
    right: -31px;
    top: 6px;
    font-size: 13px;
    color: #1483ff;
}

.teacher_replay_text {
  color:#555555;
  margin-left:3px;
  font-size: 13px;
  line-height: 20px;
}

.noticeBox{
    position: absolute;
    left: 0;
    right: 0;
    z-index: 2001;
}
.noticeBar{
  background:  #c6dbff;
  padding: 0px;
  height: 36px;
  font-size: 14px;
  text-align: center;
  color: #202020;
}
</style>
